import {
  CloseIcon,
  FieldPath,
  FieldValues,
  FormField,
  FormFieldProps,
  IconButton,
  Truncate,
} from "@theprelude/ds";
import { FileDropZone } from "../file-drop-zone";

export type InlineFileFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<FormFieldProps<TFieldValues, TFieldPath>, "children"> &
  Omit<InlineFileInputProps, "value" | "onChange">;

export const InlineFileFormField = <
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: InlineFileFormFieldProps<TFieldValues, TFieldPath>,
) => (
  <FormField {...props}>
    {(field) => <InlineFileInput {...props} {...field} />}
  </FormField>
);

interface InlineFileInputProps {
  id?: string;
  disabled?: boolean;
  required?: boolean;
  onChange?: (event: { target: { value: string } }) => void;
  value: string;
}

export const InlineFileInput = ({
  id,
  disabled,
  required,
  onChange,
  value,
}: InlineFileInputProps) => {
  if (value) {
    return (
      <div className="flex items-center justify-between gap-2 rounded border border-stroke-line px-3 py-2">
        <Truncate text={value}>{value}</Truncate>
        <IconButton
          icon={<CloseIcon />}
          onClick={() => onChange?.({ target: { value: "" } })}
        />
      </div>
    );
  }
  return (
    <FileDropZone
      id={id}
      accept={[".json"]}
      disabled={disabled}
      required={required}
      onChange={async (file) => {
        onChange?.({ target: { value: file ? await file.text() : "" } });
      }}
      className="rounded border border-stroke-line"
    />
  );
};
